import { render } from "./ModerationChatManager.vue?vue&type=template&id=9ceed1a2"
import script from "./ModerationChatManager.vue?vue&type=script&lang=js"
export * from "./ModerationChatManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__